import reducer from 'components/admins/eventlogs/reducers';
import App from 'components/admins/eventlogs/container';
import renderer from 'controllers/react_renderer';

window.app.pages.AdminsEventlogsIndex = function () {
  var store = renderer.render(reducer, App, 'react-container', {});
};
